import { useState, useCallback, useMemo } from 'react';

// utils
import retrieveMobileURL from '../utils/retrieveMobileURL';

const useMobileURL = () => {
  const [isFetching, setFetching] = useState(false);
  const [[videoId, mobileUrl], setMobileUrl] = useState(['', '']);

  const getMobileUrl = useCallback(
    async (newVideoId: string) => {
      if (newVideoId !== videoId) {
        setFetching(true);

        const fetchedMobileUrl = await (newVideoId ? retrieveMobileURL(newVideoId) : '');

        setMobileUrl([newVideoId, fetchedMobileUrl]);
        setFetching(false);

        return fetchedMobileUrl;
      }
    },
    [videoId]
  );

  return useMemo(() => [{ mobileUrl, isFetching }, getMobileUrl] as const, [mobileUrl, isFetching, getMobileUrl]);
};

export default useMobileURL;
